import { ApolloError, useQuery } from '@apollo/client'

import {
  GetPatientProfileWithEhr,
  GetPatientProfileWithEhrVariables,
  PaginationInput,
} from '../../../../models/graphqlTypes'
import { GET_PATIENT_PROFILE_EHR_DOCUMENT_LIST } from '../../../../operations/doctorPatientOperations'
import { PatientEESZTEhrDocument } from '../types/doctorPatients.types'

type Props = {
  skip: boolean
  patientId?: string
  paginationInput?: PaginationInput
}

type ReturnData = {
  total: number
  hasDORError: boolean
  patientEeszt: PatientEESZTEhrDocument[]
  loading: boolean
  error?: ApolloError
  permissionError: boolean
}

export const useDoctorPatientEESZTData = ({
  skip,
  patientId,
  paginationInput,
}: Props): ReturnData => {
  const {
    data: patientEesztData,
    error,
    loading,
  } = useQuery<GetPatientProfileWithEhr, GetPatientProfileWithEhrVariables>(
    GET_PATIENT_PROFILE_EHR_DOCUMENT_LIST,
    {
      skip: !patientId || skip,
      fetchPolicy: 'no-cache',
      variables: {
        patientId: patientId || '',
        paginationInput,
      },
    }
  )
  const documentList = patientEesztData?.getPatientProfile.ehrDocumentList
  const patientEeszt = documentList?.documents || []
  const total = patientEesztData?.getPatientProfile.ehrDocumentList.total || 0

  return {
    total,
    hasDORError: !!documentList?.hasDORError,
    patientEeszt,
    loading,
    error,
    permissionError: !!error && error.message.includes('MISSING_KAT'),
  }
}
